<template>
    <div class="container">
      <div v-show="show" class="row">
        <div class="col-4">
            <label for="inputDataInicio">Data Inicial</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="dataInicio"><i class="fas fa-calendar-alt fa-fw"></i></span>
                </div>
                <input type="date" id="inputDataInicio" name="startDate" class="form-control" aria-label="DataInicio" aria-describedby="dataInicio" v-model="startDate" required>
            </div>
        </div>
        <div class="col-4">
            <label for="inputDataFim">Data Final</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="dataFim"><i class="fas fa-calendar-alt fa-fw"></i></span>
                </div>
                <input type="date" id="inputDataFim" name="endDate" class="form-control" aria-label="DataFim" aria-describedby="dataFim"  v-model="endDate" required>
            </div>
        </div>
    </div>
    <hr v-show="show">
      <div>
        <div class="drag-area flex w-full h-screen items-center justify-center text-center" @dragover.prevent="dragOver" @dragleave="dragleave" @drop.prevent @drop="dragFile">
          <input style="display:none;" type="file" id='file-upload-ebox' accept=".csv" @change="handleFileUpload( $event )"/>
  
          <label v-show="hide" for="file-upload-ebox" class="cursor-pointer text">
            Arraste o arquivo para área azul ou <span class="underline">clique aqui</span> para subir um novo arquivo
          </label>
  
          <div v-if="file">
            {{ file.name }}
          </div>
  
          <br>
  
          <div v-if="saving" class="pb-1">
            <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Atualizando base de contatos. Por favor, aguarde...</strong></p>
          </div>
          <button v-show="hide" v-else v-on:click="submitFileEbox()"><i class="fas fa-upload"></i> Enviar</button>
        </div>
      </div>
      <div class="drag-area flex w-full h-screen items-center justify-center text-center">
        <label v-show="show" class="text">
            Clique no botão abaixo para realizar o upload das gravações referente ao arquivo utilizado.
          </label>
      <button v-show="show" id="upload" v-on:click="apiEbox()"><i class="fas fa-upload"></i> Subir Gravações</button>
      </div>
      
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        file: "",
        number: "",
        duplicate: "",
        saving: false,
        upload: false,
        show: false,
        hide: true,
        startDate: "", // Adicione startDate ao data
        endDate: "",   // Adicione endDate ao data
      };
    },
    created() {
      var firstOfTheMonth = moment().format('YYYY-MM-01')
      var now = moment().format('YYYY-MM-DD')

      this.startDate = firstOfTheMonth;
      this.endDate = now;
    },
    methods: {
      handleFileUpload(event) {
        this.file = event.target.files[0];
      },
      dragFile(e) {
        document.getElementById("file-upload-ebox").files = e.dataTransfer.files;
  
        this.file = document.getElementById("file-upload-ebox").files[0];
        console.log("file", this.file);
        // Clean up
        e.currentTarget.classList.remove("gray");
        e.currentTarget.classList.add("salmon");
      },
      dragOver(event) {
        event.currentTarget.classList.add("gray");
        event.currentTarget.classList.remove("salmon");
      },
      dragleave(event) {
        // Clean up
        event.currentTarget.classList.remove("gray");
        event.currentTarget.classList.add("salmon");
      },

      submitFileEbox() {
        this.saving = true;
        let formData = new FormData();
        let file = document.getElementById("file-upload-ebox").files[0];
  
        if (!this.file) {
          Swal.fire({
            type: "warning",
            title: "Arquivo não anexado!",
            text: "Por favor, escolha um arquivo CSV para upload!",
          });
          this.saving = false;
          return;
        }
  
        formData.append("file", file);
  
        axios.post("/records/storeEbox", formData).then((data) => {
            Swal.fire("Upload realizado", "O arquivo foi adicionado", "success");
            this.saving = false;
            document.getElementById("file-upload-ebox").value = "";
            this.file = "";
            this.$emit("updateList");
            this.show = true;
            this.hide = false;
          })
          .catch(function (error) {
            Swal.fire(
              "Erro",
              "Verifique o arquivo CSV selecionado, pode estar faltando alguma informação importante ou o formato está incorreto!<br>" +
              "<b>Lembre-se que o formato deve ser CSV UTF-8</b> ",
              "error"
            );
            console.log("FAILURE!!");
          });
      },

      apiEbox() {
        this.show = false;
        this.hide = true;
        let startDate = $("#inputDataInicio").val();
        let endDate = $("#inputDataFim").val();
        let userData = new URLSearchParams();
        userData.append('data_inicio', startDate);
        userData.append('data_fim', endDate);
        const response = axios.post('https://mettacard.advancetelecom.com.br:37499/ebox', userData).then(function ({data}) {
          Swal.fire({
            type: 'success',
            text: 'Gravações inseridas o e-box com sucesso!!'
          });
				console.log("API E-BOX", data);
			}).catch(function (err) {
        Swal.fire({
            type: 'error',
            text: 'Erro ao inserir as gravações no e-box, tente novamente!!'
          });
				console.log('Error', err.response.data);
			});
		return response;
      },

    },
  };
  </script>
  
  <style scoped>
  .text {
    padding: 1em;
  }
  
  .drag-area {
    display: block;
    width: 100%;
    background-color: rgba(28, 133, 154, 0.05);
  }
  
  .gray {
    background-color: rgba(28, 133, 154, 1);
  }
  
  .salmon {
    background-color: rgba(28, 133, 154, 0.05);
  }

  button {
    border: none;
    background-color: #1c869a;
    width: 49%;
    margin: 1em auto;
    padding: 1em;
    color: white;
    font-family: "Noto Sans KR", sans-serif;
    text-transform: uppercase;
  }

  #upload {
    border: none;
    background-color: #5cb85c;
    width: 49%;
    margin: 1em auto;
    padding: 1em;
    color: white;
    font-family: "Noto Sans KR", sans-serif;
    text-transform: uppercase;
  }
  #upload:hover {
    background-color: #60c960;
  }
  
  .underline {
    text-decoration: underline;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
  </style>